import {useGetCurrentUserQuery} from 'store/Store.js'

const useUserInfo = () => {
    const {data: user, isLoading, error} = useGetCurrentUserQuery()
    const isLoggedIn = user && !error
    const isSuperAdmin = isLoggedIn && user?.isSuper
    const isChoreographer = isLoggedIn && user?.choreographer

    return {
        user,
        isLoading,
        isLoggedIn,
        isChoreographer,
        isSuperAdmin,
    }
}

export default useUserInfo
